// NADA Naturals: botón "Agregar" del bloque "Completa tu rutina" (Horizon, versión con @shopify/events).
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

if (!window.__nadaCartUpsell) {
  window.__nadaCartUpsell = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target ? target.closest('[data-cart-upsell-add]') : null;
    if (!button || button.hasAttribute('disabled')) return;

    event.preventDefault();
    button.setAttribute('disabled', '');

    const variantId = button.dataset.variantId;
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.message || data.description || 'No se pudo agregar');

      const cartResponse = await fetch(`${Theme.routes.cart_url}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const cart = await cartResponse.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'cart-upsell',
          itemCount: 1,
          sections: data.sections,
          didError: false,
        },
      });
    } catch (error) {
      console.error(error);
      deferred.reject(error);
      button.removeAttribute('disabled');
      document.dispatchEvent(
        new CartErrorEvent({
          error: error?.message || 'No se pudo agregar',
          code: 'INVALID',
        })
      );
    }
  });
}